export default "/images/close.svg?6e28b9330dd9c154aff5dd8eec5cb26d";